<template>
    <div class="intro" :class="{contact: notbar, productpage: notbarproduct}">
        <h2 class="intro__title">{{title}}</h2>
    </div>
</template>

<script>
    export default {
        name: "Intro",
        props: ['title', 'notbar', 'notbarproduct']
    }
</script>

<style lang="scss" scoped>
    .intro {
        height: 170px;
        margin-top: 83px;
        margin-bottom: 60px;
        background-image: url('../../assets/backgrounds/page-intro-bg.svg');
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        position: relative;

        &__title {
            padding-top: 50px;
            color: #fff;
            text-align: center;
            font-family: HelveticaNeueMedium, Arial, sans-serif;
            font-weight: 500;
            font-size: 2.375rem;
        }
    }

    .contact {
        margin-bottom: 80px;
    }

    .contact::after {
        display: none;
    }

    .productpage {
        margin-bottom: 20px;
        &::after {
            display: none;
        }
    }

    @media only screen and(max-width: 1200px) {
        .intro {
            margin-top: 79px;
        }

        .intro__title {
            font-size: 2rem;
        }
    }

    @media only screen and (max-width: 767px) {
        .contact {
            margin-bottom: 60px;
        }

        .intro {
            margin-bottom: 40px;
        }
    }
</style>